import { render } from "./UserType.vue?vue&type=template&id=04a7d0b2"
import script from "./UserType.vue?vue&type=script&lang=js"
export * from "./UserType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__